import { planMasterType } from '@agentcall/core/type'

export type PlanMaster = {
  id: planMasterType.id
  name: planMasterType.name
  monthlyPrice: planMasterType.monthlyPrice
  description: planMasterType.description
  isActive: planMasterType.isActive
  features: string[]
}

export const planMasters: PlanMaster[] = [
  {
    id: planMasterType.PLAN_MASTER_ID_STANDARD,
    name: 'スタンダードプラン',
    monthlyPrice: 1100,
    description: 'スタンダードプラン',
    isActive: true,
    features: ['24hコールセンター', '共用部駆けつけサービス'],
  },
  {
    id: planMasterType.PLAN_MASTER_ID_PLUS,
    name: 'プラスプラン',
    monthlyPrice: 1650,
    description: 'プラスプラン',
    isActive: true,
    features: [
      '24hコールセンター',
      '入居者保険（総括保険）',
      '緊急サポートサービス（専有部）',
      '共用部駆けつけサービス',
    ],
  },
  // Echoes 経由オーナー専用。AgentCall 側では課金しない(Echoes が請求する)ため 0 円。
  {
    id: planMasterType.PLAN_MASTER_ID_ECHOES_FULL,
    name: 'エコーズフルプラン',
    monthlyPrice: 0,
    description:
      'Echoes 経由オーナー専用のフルプラン(火災保険・駆けつけ・コールセンター)',
    isActive: true,
    features: ['24hコールセンター', '火災保険', '駆けつけサービス'],
  },
  {
    id: planMasterType.PLAN_MASTER_ID_ECHOES_CALL_CENTER,
    name: 'エコーズコールセンタープラン',
    monthlyPrice: 0,
    description: 'Echoes 経由オーナー専用のコールセンターのみプラン',
    isActive: true,
    features: ['24hコールセンター'],
  },
]

/** Echoes 外部連携 API の Tenant.plan_id → AgentCall プランマスタ ID。 */
export const getPlanMasterIdByEchoesPlanId = (
  echoesPlanId: number,
): string | undefined =>
  ({
    1: planMasterType.PLAN_MASTER_ID_ECHOES_FULL,
    2: planMasterType.PLAN_MASTER_ID_ECHOES_CALL_CENTER,
  })[echoesPlanId]

export const getPlanMaster = (id: string): PlanMaster | undefined => {
  return planMasters.find((planMaster) => planMaster.id === id)
}

export const activePlanMasters = planMasters.filter(
  (planMaster) => planMaster.isActive,
)
